export default __webpack_public_path__ + "static/media/compass.211e022c.png";